import * as React from 'react';
import * as videoPresentation from './videoPresentation.module.scss';
import { Modal } from '../../../../Modal';
import { TaxDeduction } from "../../../../TaxDeduction";

export const VideoPresentation = ({ buttonText, widget, showButton }) => {
  const [showModal, setShowModal] = React.useState(false);

  return (
    <section>
      <div className="container">
        {
          showButton ?
          <>
            <button
              className={videoPresentation.videoPresentation__btn}
              onClick={() => {
                setShowModal(true);
              }}
            >
              {buttonText}
            </button>
            <TaxDeduction margin={"30px 0 50px"} align={"center"}/>
          </>
          : null}

        <div className={videoPresentation.videoPresentation__video}>
          <div className={videoPresentation.videoPresentation__videoWrapper}>
            <iframe
              src="https://www.youtube.com/embed/EGrw3oQ2vXg"
              title={'Знакомство с курсом'}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
          <p className={videoPresentation.videoPresentation__videoText}>
            2-минутное видеознакомство с&nbsp;курсом «Учись учиться»
          </p>
        </div>
      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        {widget}
      </Modal>
    </section>
  );
};
